export default __webpack_public_path__ + "static/media/stool.5ad02f45.jpg";